import {FunctionComponentElement} from "react";
import {InputText} from "primereact/inputtext";
import {NodeInputProps} from "./index";
import styles from "./Form.module.scss"

export const ErrorInput = ({type, value, onChange}: NodeInputProps): FunctionComponentElement<NodeInputProps> =>{
    console.error("invalid field type:", type)
    return <InputText className={styles.error} value={value} onChange={(e) => onChange(e.target.value)}/>
}